import React, { useContext, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tools from "./JNSTools";
import DashboardRAIDComponent from "./DashboardRAIDComponent";
import { CredsContext } from "./Contexts";

function DashboardRAIDContainer(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const projectId = useRef(projectObject.id);
  const useThisData = useRef();
  const [dataArray, setDataArray] = useState();
  const finished = useRef(false);
  let ISSUE_CATEGORY_ID;
  let initiateWait = false;

  const storedItems = sessionStorage.getItem(
    "dashboardItemList_" + props.raidType,
  );
  const oadaSettingsRaw = localStorage.getItem("oadaSettings");
  if (oadaSettingsRaw) {
    const oadaSettings = JSON.parse(oadaSettingsRaw);

    ISSUE_CATEGORY_ID =
      oadaSettings[props.raidType + "CategoryDropdown_options"];
  }

  useEffect(() => {
    if (!storedItems) {
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const requestString =
        authString +
        '<Read type="Issue" method="equal to" enable_custom="1" limit="1000"><Issue><project_id>' +
        projectId.current +
        "</project_id></Issue></Read></request>";

      Tools.fetchPost(requestString, urlString, "Issue").then(
        (itemResponse) => {
          let itemArray = [];
          if (itemResponse.xml.length > 0) {
            const initialItemArray = Tools.xmlToArray(itemResponse.xml);
            itemArray = initialItemArray.filter(
              (item) => item.issue_category_id == ISSUE_CATEGORY_ID,
            );

            const issueSeverities = JSON.parse(
              localStorage.getItem(creds.company + "|IssueSeverity"),
            );
            const issueStages = JSON.parse(
              localStorage.getItem(creds.company + "|IssueStage"),
            );
            itemArray.forEach((elem) => {
              const severityRecord = issueSeverities.find(
                (severity) => severity.id == elem.issue_severity_id,
              );
              if (severityRecord) {
                elem.issue_severity_name = severityRecord.name;
              } else if (elem.issue_severity_id == "") {
                elem.issue_severity_id = -1;
              }
              const stageRecord = issueStages.find(
                (stage) => stage.id == elem.issue_stage_id,
              );
              if (stageRecord) {
                elem.issue_stage_name = stageRecord.name;
              }
            });
            useThisData.current = itemArray;
          }
          finished.current = true;
          sessionStorage.setItem(
            "dashboardItemList_" + props.raidType,
            JSON.stringify(itemArray),
          );
          setDataArray(itemArray);
        },
      );
    } else {
      finished.current = true;
      const storedItemsArray = JSON.parse(storedItems);
      useThisData.current = storedItemsArray;
      setDataArray(storedItemsArray);
    }
  }, []);
  return (
    <DashboardRAIDComponent
      dataArray={useThisData.current}
      panelLocked={props.panelLocked}
      removePanel={props.removePanel}
      panelId={props.panelId}
      finished={finished.current}
      initiateWait={initiateWait}
      raidType={props.raidType}
      statusVersion={props.statusVersion}
    ></DashboardRAIDComponent>
  );
}

export default DashboardRAIDContainer;

DashboardRAIDContainer.propTypes = {
  inPanel: PropTypes.bool,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  raidType: PropTypes.string,
  statusVersion: PropTypes.bool,
};
